import { PageInfo } from './vo/page-info.model';
import { GetFeatureThemaSelectItemsResponse } from './api-services/get-feature-thema-select-items.service';
import { GetUserManagementSelectItemsResponse } from './api-services/get-user-management-select-items.service';
import { GetPageTemplateSelectItemsResponse } from './api-services/get-page-template-select-items.service';
import { GetPublishGoodsGroupSelectItemsResponse } from './api-services/get-publish-goods-group-select-items.service';
import { GetTagListResponse } from './api-services/get-tag-list.service';
import { GetAutoKomaArrangePatternListResponse } from './api-services/get-auto-koma-arrange-pattern-list.service';
import { GetCodeListResponse } from '../../../commons/kymw02/api-services/get-code-list.service';

/**
 * 自動コマ配置画面の値を管理するクラス
 *
 * @export KYMW4400Model
 * @class KYMW4400Model
 */
export class KYMW4400Model {
  private static readonly PLAN_FIXED_TRUE = '1';
  private static readonly PLAN_FIXED_FALSE = '0';
  // ページパターン 自動選択
  public static readonly PAGE_TEMPLATE_AUTOSELECT = 'autoSelect';

  // 媒体
  public mediumType = '';
  // 受注コード
  public orderCode = '';
  // 企画回
  public catalogId = '';
  // 会員生協
  public coopCode = '';
  // コピー元受注コード
  public originalOrderCode = '';
  // コピー元生協コード
  public originalCoopCode = '';

  // 一覧取得時のパラメータ
  public searchedMediumType = '';
  public searchedOrderCode = '';
  public searchedCatalogId = '';
  public searchedCoopCode = '';

  // 編集可否フラグ
  public isEditable = false;

  // ページ情報一覧
  public pageList: PageInfo[] = [];
  public pageListOrigin: PageInfo[] = [];

  // ページ情報一覧 選択項目
  public featureSelectItems: GetFeatureThemaSelectItemsResponse = [];
  public contactUserSelectItems: GetUserManagementSelectItemsResponse = [];
  public pageTemplateSelectItems: GetPageTemplateSelectItemsResponse = [];
  public publishGoodsGroupSelectItems: GetPublishGoodsGroupSelectItemsResponse = [];
  public tagSelectItems: GetTagListResponse = [];
  public commonPublishFlgSelectItems: GetCodeListResponse = [];
  public autoArrangePatternSelectItems: GetAutoKomaArrangePatternListResponse = [];

  // CSVファイルパス
  public csvPath: string = '';

  setPlanFixed(s: string) {
    this.isEditable = s === KYMW4400Model.PLAN_FIXED_TRUE ? false : true;
  }

  get hasChecked() {
    return this.pageList.some(_ => _.check);
  }

  get registPages() {
    return this.pageList.filter(_p => !/^\d+$/.test(_p.pageId));
  }

  get deletePages() {
    const holdPages = this.pageList.map(_t => _t.pageId);
    return this.pageListOrigin.filter(_t => !holdPages.includes(_t.pageId));
  }

  get updatePages() {
    return this.pageList.filter(_p =>
      this.pageListOrigin.find(
        _o =>
          _o.pageId === _p.pageId &&
          (_o.pageNum !== _p.pageNum ||
            _o.folio !== _p.folio ||
            _o.pageInfo !== _p.pageInfo ||
            _o.webCatalogTitle !== _p.webCatalogTitle ||
            this.formatPageTemplateId(_o.pageTemplateId) !== this.formatPageTemplateId(_p.pageTemplateId) ||
            _o.contactUser1 !== _p.contactUser1 ||
            _o.contactUser2 !== _p.contactUser2 ||
            _o.contactUser3 !== _p.contactUser3 ||
            _o.feature1 !== _p.feature1 ||
            _o.feature2 !== _p.feature2 ||
            _o.feature3 !== _p.feature3 ||
            _o.autoArrangePattern !== _p.autoArrangePattern ||
            _o.commonPublishFlg !== _p.commonPublishFlg ||
            !(
              _o.publishGoodsGroupIdList.every(_ =>
                _p.publishGoodsGroupIdList.includes(_)
              ) &&
              _p.publishGoodsGroupIdList.every(_ =>
                _o.publishGoodsGroupIdList.includes(_)
              )
            ) ||
            !(
              _o.tagIdList.every(_ => _p.tagIdList.includes(_)) &&
              _p.tagIdList.every(_ => _o.tagIdList.includes(_))
            ))
      )
    );
  }

  get registKoma() {
    return this.pageList.filter(_ => _.check);
  }

  /**
   * pageTemplateIdの変換処理
   * 元データが空文字の場合「autoSelect」に置き換え、それ以外はそのままの値で返す。
   *
   * @param pageTemplateId 変換対象のpageTemplateId
   * @returns pageTemplateId 変換後のpageTemplateId
   */
  formatPageTemplateId(pageTemplateId: string): string {
    return pageTemplateId === '' ? KYMW4400Model.PAGE_TEMPLATE_AUTOSELECT : pageTemplateId;
  }
}
